/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Bot_Approve_AllInputs */

const tr_landing_pricerules_mock_bot_approve_all = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Approve_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tümünü onayla`)
};

const en_landing_pricerules_mock_bot_approve_all = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Approve_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve all`)
};

const de_landing_pricerules_mock_bot_approve_all = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Approve_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle freigeben`)
};

const ru_landing_pricerules_mock_bot_approve_all = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Approve_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одобрить все`)
};

/**
* | output |
* | --- |
* | "Approve all" |
*
* @param {Landing_Pricerules_Mock_Bot_Approve_AllInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_bot_approve_all = /** @type {((inputs?: Landing_Pricerules_Mock_Bot_Approve_AllInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Bot_Approve_AllInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_bot_approve_all(inputs)
	if (locale === "de") return de_landing_pricerules_mock_bot_approve_all(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_bot_approve_all(inputs)
	return tr_landing_pricerules_mock_bot_approve_all(inputs)
});